import { gozokiApiWithAuth } from '../gozokiApi';

export const chargePreAuthorization = async ({
    storeId,
    preAuthorizationId,
    amount,
}: {
    storeId: number;
    preAuthorizationId: number;
    amount: number;
}) => {
    const response = await gozokiApiWithAuth.patch(
        `/stores/${storeId}/pre-authorizations/${preAuthorizationId}/charge`,
        { amount }
    );
    return response;
};
